import { render, staticRenderFns } from "./CardBalance.vue?vue&type=template&id=df1313ca&scoped=true&"
import script from "./CardBalance.vue?vue&type=script&lang=ts&"
export * from "./CardBalance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1313ca",
  null
  
)

export default component.exports